import * as React from "react"
import { connect } from "react-redux"

import {
    Body,
    CompleteFooter,
    LoadingBody,
    Table,
} from "@tenforce/toolbox-table-react"

import { GlobalState } from "../../../store"

import { DispatchProps, mapDispatchToProps } from "../actions"
import { getSortedAddins } from "../selectors"
import { Labels } from "../../../util/Translations"

import Row from "./Row"
import TableHeader from "./TableHeader"

interface StateProps {
    sortedAddins: Addins.Addin[]
    isLoading: boolean
}

type Props = StateProps & DispatchProps

export const Addins = ({
    sortedAddins,
    requestAddins,
    isLoading,
}: Props): JSX.Element => {
    const { InstalledAddins } = Labels
    return (
        <div className="tw-mx-8 tw-mb-5">
            <h4 className="tw-mb-5">{InstalledAddins}</h4>

            <Table data-ft-addins-table>
                <TableHeader />

                {isLoading ? (
                    <LoadingBody id="addinsLoading" />
                ) : (
                    <Body>
                        {sortedAddins.map((addin) => (
                            <Row
                                key={addin.addInName}
                                addin={addin}
                                requestAddins={requestAddins}
                            />
                        ))}
                    </Body>
                )}

                <CompleteFooter />
            </Table>
        </div>
    )
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    isLoading: state.addins.isLoading,
    sortedAddins: getSortedAddins(state.addins),
})

export default connect(mapStateToProps, mapDispatchToProps)(Addins)
